import React from "react";
import * as S from "./styles";

const ModalParagraph = ({ children }) => {
  return <S.Paragraph>{children}</S.Paragraph>;
};

export default ModalParagraph;
